// extracted by mini-css-extract-plugin
export default {"connecting":"ttJ81CwlMJ0MM3i7gn4L","waiting":"iFlwtzLfrl_Ry8x3XEWh","duration":"iIb5Cuu25K0dRqdhjl6V"};